import { useNavigate } from 'react-router-dom';

export default function Navbar({ isScrolled }: { isScrolled: boolean }) {
  const navigate = useNavigate();

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  const navItems = [
    { label: '프로젝트 개요', id: 'overview' },
    { label: '필지 분석', id: 'land-analysis' },
    { label: '설계 컨셉', id: 'design' },
    { label: '배치도', id: 'floorplan' },
    { label: '스마트 시설', id: 'smart' },
    { label: '주차 & 접근성', id: 'parking' },
    { label: '수지 분석', id: 'feasibility' },
    { label: '인허가 일정', id: 'permit-schedule' },
    { label: '종합 로드맵', id: 'roadmap', isPage: true },
    { label: '문의하기', id: 'contact' }
  ];

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md' : 'bg-transparent'}`}>
      <div className="w-full px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center cursor-pointer" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
            <img 
              src="https://public.readdy.ai/ai/img_res/6c216717c879f05dbacbec0623e2ce67.jpg" 
              alt="서초동 복합개발" 
              className="h-10"
            />
          </div>
          <div className="hidden lg:flex items-center space-x-8">
            {navItems.map((item, index) => (
              <button
                key={index}
                onClick={() => {
                  if ((item as any).isPage) {
                    navigate('/roadmap');
                  } else {
                    scrollToSection(item.id);
                  }
                }}
                className={`text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                  (item as any).isPage
                    ? isScrolled ? 'text-teal-600 hover:text-teal-700 font-bold' : 'text-teal-300 hover:text-white font-bold'
                    : isScrolled ? 'text-gray-700 hover:text-teal-600' : 'text-white hover:text-teal-400'
                }`}
              >
                {(item as any).isPage && <i className="ri-route-line mr-1"></i>}
                {item.label}
              </button>
            ))}
          </div>
        </div>
      </div>
    </nav>
  );
}
